import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  RESET_PROJECT_IDENTIFICATION_LIST,
  LOAD_PROJECT_IDENTIFICATION_LIST,
  LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS,
  LOAD_PROJECT_IDENTIFICATION_LIST_ERROR,
  LOAD_PROJECT_IDENTIFICATION_DETAIL,
  LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS,
  LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR,
  UPDATE_PROJECT_IDENTIFICATION,
  UPDATE_PROJECT_IDENTIFICATION_SUCCESS,
  UPDATE_PROJECT_IDENTIFICATION_ERROR,
  CREATE_PROJECT_IDENTIFICATION,
  CREATE_PROJECT_IDENTIFICATION_SUCCESS,
  CREATE_PROJECT_IDENTIFICATION_ERROR,
} from '../type';

const projectIdentificationReducer = handleActions(
  new Map([
    [
      RESET_PROJECT_IDENTIFICATION_LIST,
      state => {
        return update(state, {
          projectIdentificationList: {
            data: { $set: [] },
            offset: { $set: 0 },
            limit: { $set: 0 },
            total: { $set: 0 },
          },
        });
      },
    ],
    [
      LOAD_PROJECT_IDENTIFICATION_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            projectIdentificationListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            projectIdentificationListLoading: { $set: false },
          },
          projectIdentificationList: {
            data: { $set: action.payload.data },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_PROJECT_IDENTIFICATION_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            projectIdentificationListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Load package detail
    [
      LOAD_PROJECT_IDENTIFICATION_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            projectIdentificationDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            projectIdentificationDetailLoading: { $set: false },
          },
          projectIdentificationDetail: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            projectIdentificationDetailLoading: { $set: true },
          },
        });
      },
    ],

    //Create package
    [
      CREATE_PROJECT_IDENTIFICATION,
      state => {
        return update(state, {
          loadingStatus: {
            createProjectIdentificationLoading: { $set: true },
          },
        });
      },
    ],
    [
      CREATE_PROJECT_IDENTIFICATION_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            createProjectIdentificationLoading: { $set: false },
          },
        });
      },
    ],
    [
      CREATE_PROJECT_IDENTIFICATION_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            createProjectIdentificationLoading: { $set: false },
          },
        });
      },
    ],

    //Update package
    [
      UPDATE_PROJECT_IDENTIFICATION,
      state => {
        return update(state, {
          loadingStatus: {
            updateProjectIdentificationLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_PROJECT_IDENTIFICATION_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updateProjectIdentificationLoading: { $set: false },
          },
          projectIdentificationDetail: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_PROJECT_IDENTIFICATION_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            updateProjectIdentificationLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default projectIdentificationReducer;
